import React from 'react'
import { Field } from '@/components/PickupModal.styles'
import { Textfield } from '@big-red-group/storefront-common-ui'

type CustomPickupProps = {
  onChange: (pickup: string) => void
  location?: string
}

const CustomPickup: React.FC<CustomPickupProps> = ({ onChange, location }) => {
  const handleOnChange = (e: React.FormEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value)
  }

  return (
    <Field>
      <label>Please enter your hotel name in the field below</label>
      <Textfield placeholder="e.g. Hilton Surfers Paradise" onChange={handleOnChange} value={location} />
    </Field>
  )
}

export default CustomPickup
